import React, { useState } from "react";
import Button from "@mui/material/Button";
import ManageSearch from "@mui/icons-material/ManageSearch";

import DialogHistoryProjectTimeEntry from "@repo/legacy/components/shared/dialogs/DialogHistoryProjectTimeEntry";

import type { ProjectTimeEntry } from "@repo/server-api";
import type { NewTimeEntry } from "./types";

export const HistoryCell = ({ entry }: { entry: ProjectTimeEntry | NewTimeEntry }) => {
	const [openHistory, setOpenHistory] = useState(false);

	if (entry.id.match(/^new*/)) return null;
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}>
			<Button
				disabled={!entry.history?.length}
				variant="contained"
				className="blueButton"
				color="secondary"
				onClick={() => {
					setOpenHistory(!openHistory);
				}}
				style={{
					width: "50px",
					height: "25px",
					margin: "5px auto",
				}}>
				<ManageSearch />
			</Button>
			<DialogHistoryProjectTimeEntry
				open={openHistory}
				setOpen={setOpenHistory}
				history={entry.history}
			/>
		</div>
	);
};
